/**
 * Checks if the second-to-last production item is fully out of view
 * relative to the top of the production list container.
 *
 * If the penultimate item has scrolled out of view, a modifier class
 * (`archive_production-productions--end`) is added to the production list.
 * This can be used for UI effects such as revealing a footer or showing
 * an "end of list" visual indicator.
 *
 * NOTE: search breaks this logic by sometimes hiding the seccond-to-last item, so this is disabled
 * 
 * @param {number} offset - Optional pixel offset to fine-tune detection threshold.
 */
export function checkPenultimateItemOutOfView(offset = 0) {
/*
  const scrollContainer = document.querySelector(
    '.archive_production-productions',
  );
  if (!scrollContainer) return;

  const items = scrollContainer.querySelectorAll(
    '.archive_production-production',
  );
  if (items.length < 2) return;

  const penultimateItem = items[items.length - 1];
  const containerTop = scrollContainer.getBoundingClientRect().top;
  const itemRect = penultimateItem.getBoundingClientRect();
  const itemHeight = penultimateItem.offsetHeight;

  const isOutOfView = itemRect.top <= containerTop - itemHeight + offset;

  scrollContainer.classList.toggle(
    'archive_production-productions--end',
    isOutOfView,
  );
  */
}

/**
 * Sets up breakpoint media query listeners.
 */
export function setupBreakpoints() {
  const breakpoints = {
    sm: window.matchMedia('(min-width: 576px)'),
    md: window.matchMedia('(min-width: 768px)'),
    lg: window.matchMedia('(min-width: 992px)'),
    xl: window.matchMedia('(min-width: 1200px)'),
    xxl: window.matchMedia('(min-width: 1400px)'),
  };

  Object.values(breakpoints).forEach(mq => {
    mq.addEventListener('change', handleBreakpointChange);
  });
}

/**
 * Handles breakpoint changes and triggers UI updates.
 */
export function handleBreakpointChange() {
  checkPenultimateItemOutOfView();
}
